export const keys = {
    all: ["well-summary"],
    configurationLists: () => [
        ...keys.all,
        "configuration-list"
    ],
    configurationList: (groupID: number) => [
        ...keys.configurationLists(),
        {
            groupID
        }
    ],
    summaryDatas: () => [
        ...keys.all,
        "summary-data"
    ],
    summaryData: (customerID: number, groupID: number, offline: boolean, configurationID?: number) => [
        ...keys.summaryDatas(),
        {
            customerID,
            groupID,
            offline,
            configurationID
        }
    ]
};
